import React, { useState, useEffect, useCallback } from 'react';
import './../../App.css';
import './../Transaction/Transactions.css';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { CreateSearchBarWithPlaceHolder, CreateButton } from '../CommonObjects';
import {SetAuditTrail, SetAuditTrailBulk} from './../Reports/AuditTrailReportEmployeeSetup';
import axios from 'axios';
import {CreateTableForEmployeeSelect} from '../ManageTable';
import {token, domain, isLoanFullView} from '../Security';
import loadingSpinner from './../../assets/loading.gif';
import {useTable, useSortBy} from 'react-table';
import {globalTimeFormat} from './../Security';
// icon
import SearchIcon from '@mui/icons-material/Search';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';

function Benefits({user, userAccess, isHideSideMenu}) {
    const [canFullView, setCanFullView] = useState(false);

    console.log({canFullView})

    useEffect(() => {
        setCanFullView(isLoanFullView(userAccess.description));
    }, [userAccess]);

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [loadingBeneficiary, setLoadingBeneficiary] = useState(false);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [benefits, setBenefits] = useState([]);
    const [beneficiary, setBeneficiary] = useState([]);
    const [type, setType] = useState(0);
    // Retrieve
    const [filterData, setFilterData] = useState([]);
    const [filterDataBeneficiary, setFilterDataBeneficiary] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [filterDataIndexBeneficiary, setFilterDataIndexBeneficiary] = useState(0);
    const [dataToFetch, setDataToFetch] = useState("");
    const [searchPlaceholderBenefit, setSearchPlaceholderBenefit] = useState("Search by benefit name");
    const [searchPlaceholderBeneficiary, setSearchPlaceholderBeneficiary] = useState("Search by employee name");
    // Add
    //      Benefits
    const [showAddForm, setShowAddForm] = useState(false);
    const [name, setName] = useState("");
    const [amount, setAmount] = useState("");
    const [benefitType, setBenefitType] = useState("");
    const [isActive, setIsActive] = useState(false);
    //      Beneficiary
    const [showAddFormBeneficiary, setShowAddFormBeneficiary] = useState(false);
    const [employeePersonalInformationId, setEmployeePersonalInformationId] = useState("");
    const [employeePersonalInformationFullName, setEmployeePersonalInformationFullName] = useState("");
    const [benefitId, setBenefitId] = useState("");
    const [payTypeId, setPayTypeId] = useState("");
    const [isActiveBeneficiary, setIsActiveBeneficiary] = useState(false);
    //Update
    //      Benefits
    const [showEditForm, setShowEditForm] = useState(false);
    const [editById, setEditById] = useState("");
    const [editName, setEditName] = useState("");
    const [editAmount, setEditAmount] = useState("");
    const [editBenefitType, setEditBenefitType] = useState("");
    const [editIsActive, setEditIsActive] = useState("");
    //Old
    const [oldEditName, setOldEditName] = useState("");
    const [oldEditAmount, setOldEditAmount] = useState("");
    const [oldEditIsActive, setOldEditIsActive] = useState("");
    //      Beneficiary
    const [showEditFormBeneficiary, setShowEditFormBeneficiary] = useState(false);
    const [editByIdBeneficiary, setEditByIdBeneficiary] = useState("");
    const [editEmployeePersonalInformationIdBeneficiary, setEditEmployeePersonalInformationIdBeneficiary] = useState("");
    const [editEmployeePersonalInformationFullName, setEditEmployeePersonalInformationFullName] = useState("");
    const [editBenefitIdBeneficiary, setEditBenefitIdBeneficiary] = useState("");
    const [editPayTypeIdBeneficiary, setEditPayTypeIdBeneficiary] = useState("");
    const [editIsActiveBeneficiary, setEditIsActiveBeneficiary] = useState(false);
    //old
    const [oldEditBenefitIdBeneficiary, setOldEditBenefitIdBeneficiary] = useState("");
    const [oldEditPayTypeIdBeneficiary, setOldEditPayTypeIdBeneficiary] = useState("");
    const [oldEditIsActiveBeneficiary, setOldEditIsActiveBeneficiary] = useState(false);
    // Delete
    const [showDeleteForm, setShowDeleteForm] = useState(false);
    const [deleteById, setDeleteById] = useState([]);

    const [showEmployeeForm, setShowEmployeeForm] = useState(false);
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const apiUrl =  domain + "/api/Benefit";
    const apiUrlBeneficiary =  domain + "/api/Beneficiary";

    const fetchData = useCallback(async (dataToFetch) => {
        try {
            setLoading(true);
            const response = await axios.get(apiUrl + dataToFetch , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
            setBenefits(response.data); // Set the response data to the state
            setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [apiUrl]);

    const fetchDataBeneficiary = useCallback(async (dataToFetch) => {
        try {
            setLoadingBeneficiary(true);
            const response = await axios.post(`${apiUrlBeneficiary}/get-data`, user,{
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
            setBeneficiary(response.data); // Set the response data to the state
            setFilterDataBeneficiary(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
            setLoadingBeneficiary(false);
        } finally {
            setLoadingBeneficiary(false); // Set loading state to false after data fetching is complete
        }
    }, [apiUrlBeneficiary, user]);

    useEffect(() => {
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholderBenefit("Search by benefit name");
                setDataToFetch("");
                break;
            case 1:
                setSearchPlaceholderBenefit("Search by benefit name");
                setDataToFetch("/active")
                break;
            case 2:
                setSearchPlaceholderBenefit("Search by benefit id");
                setDataToFetch("");
                break;
            default:
                setSearchPlaceholderBenefit("Search by benefit name");
                setDataToFetch("");
                break;
        }

        switch (filterDataIndexBeneficiary) {
            case 0:
                setSearchPlaceholderBeneficiary("Search by employee name");
                setDataToFetch("");
                break;
            case 1:
                setSearchPlaceholderBeneficiary("Search by beneficiary id");
                setDataToFetch("/active")
                break;
            default:
                setSearchPlaceholderBeneficiary("Search by employee name");
                setDataToFetch("");
                break;
        }
        
        fetchData(dataToFetch);
        fetchDataBeneficiary();
        
    }, [fetchData, fetchDataBeneficiary, filterDataIndex, filterDataIndexBeneficiary, dataToFetch, type]);

    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.name.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.name.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 2:
                res = filterData.filter((f) =>
                f.id.toString().startsWith(value)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.name.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }
    
        setBenefits(res);
    };
    const handleFilterBeneficiary = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndexBeneficiary) {
            case 0:
                res = filterDataBeneficiary.filter((f) =>
                f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterDataBeneficiary.filter((f) =>
                f.employeePersonalInformationEmployeeId.toLowerCase().includes(lowercaseValue)
                );
                break;
            default:
                res = filterDataBeneficiary.filter((f) =>
                f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }

        setBeneficiary(res);
    };
    const handleSubmit = async (event) => {
        event.preventDefault();

        const data = {
            name: name,
            amount: amount,
            type: benefitType,
            isActive: isActive
        };

        try {
            setLoadingRequest(true);
            await axios.post(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            setShowAddForm(false); // Hide the add form
            await SetAuditTrail({
                setupArea: "Benefits", 
                actionTaken: "insert", 
                field: "Add Benefit", 
                newValue: `${data.name}`, 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });
            await fetchData(""); // Assuming fetchData() fetches the updated data for the table
            await fetchDataBeneficiary();

            console.log('Data added successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            setName("");
            setAmount("");
            setBenefitType("");
            setIsActive(false);
        } catch (error) {
            setLoadingRequest(false);
            console.error('There was a problem adding data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowAddForm(false);
    };
    const handleSubmitBeneficiary = async (event) => {
        event.preventDefault();

        const data = {
            employeePersonalInformationId: employeePersonalInformationId,
            benefitId: benefitId,
            // payTypeId: payTypeId,
            isActive: isActiveBeneficiary
        };

        console.log('Final bulkData:', JSON.stringify(data, null, 2));

        try {
            setLoadingRequest(true);
            await axios.post(apiUrlBeneficiary, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            setShowAddFormBeneficiary(false); // Hide the add form
            await SetAuditTrail({
                setupArea: "Benefits", 
                actionTaken: "insert", 
                field: "Add Beneficiary", 
                newValue: `${employeePersonalInformationFullName}`, 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });
            await fetchData(""); // Assuming fetchData() fetches the updated data for the table
            await fetchDataBeneficiary();

            console.log('Data added successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            setEmployeePersonalInformationId("");
            setBenefitId("");
            setPayTypeId("");
        } catch (error) {
            setLoadingRequest(false);
            console.error('There was a problem adding data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowAddFormBeneficiary(false);
    };
    const handleUpdate = async (event) => {
        event.preventDefault();

        const data = {
            name: editName,
            amount: editAmount,
            type: editBenefitType,
            isActive: editIsActive
        };

        try {
            setLoadingRequest(true);
            await axios.put(apiUrl + `/${editById}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            let auditInfo = [];

            if(data.name !== oldEditName){
                auditInfo.push({
                    setupArea: "Benefits",
                    actionTaken: "update benefit",
                    field: "Name",
                    newValue: `${data.name}`,
                    oldValue: `${oldEditName}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.amount !== oldEditAmount){
                auditInfo.push({
                    setupArea: "Benefits",
                    actionTaken: "update benefit",
                    field: "Amount",
                    newValue: `${data.amount}`,
                    oldValue: `${oldEditAmount}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.isActive !== oldEditIsActive){
                auditInfo.push({
                    setupArea: "Benefits",
                    actionTaken: "update benefit",
                    field: "Is Active?",
                    newValue: `${data.isActive ? "Active" : "InActive"}`,
                    oldValue: `${oldEditIsActive ? "Active" : "InActive"}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            setShowEditForm(false);
            await SetAuditTrailBulk({data: auditInfo});
            await fetchData(""); // Assuming fetchData() fetches the updated data for the table
            await fetchDataBeneficiary();

            console.log('Data updated successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);

            // Reload table data and reset form fields
            setEditName("");
            setEditAmount("");
            setEditBenefitType("");
            setEditIsActive("");
            setEditById("");
        } catch (error) {
            setLoadingRequest(false);
            console.error('There was a problem updating data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowEditForm(false);
    };
    const handleUpdateBeneficiary = async (event) => {
        event.preventDefault();

        const data = {
            employeePersonalInformationId: editEmployeePersonalInformationIdBeneficiary,
            benefitId: editBenefitIdBeneficiary,
            // payTypeId: editPayTypeIdBeneficiary,
            isActive: editIsActiveBeneficiary
        };

        try {
            setLoadingRequest(true);
            await axios.put(apiUrlBeneficiary + `/${editByIdBeneficiary}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            let auditInfo = [];

            if(data.benefitId !== oldEditBenefitIdBeneficiary){
                auditInfo.push({
                    setupArea: "Benefit",
                    actionTaken: "update beneficiary",
                    field: "Benefit Type",
                    newValue: `${data.benefitId}`,
                    oldValue: `${oldEditBenefitIdBeneficiary}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.payTypeId !== oldEditPayTypeIdBeneficiary){
                auditInfo.push({
                    setupArea: "Benefit",
                    actionTaken: "update beneficiary",
                    field: "Pay Type",
                    newValue: `${data.payTypeId}`,
                    oldValue: `${oldEditPayTypeIdBeneficiary}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.isActive !== oldEditIsActiveBeneficiary){
                auditInfo.push({
                    setupArea: "Benefit",
                    actionTaken: "update beneficiary",
                    field: "Is Active",
                    newValue: `${data.isActive}`,
                    oldValue: `${oldEditIsActiveBeneficiary}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            setShowEditFormBeneficiary(false);
            await SetAuditTrailBulk({data: auditInfo});
            await fetchData(""); // Assuming fetchData() fetches the updated data for the table
            await fetchDataBeneficiary(); // Assuming fetchData() fetches the updated data for the table

            console.log('Data updated successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);

            // Reload table data and reset form fields
            setEditEmployeePersonalInformationIdBeneficiary("");
            setEditBenefitIdBeneficiary("");
            setEditPayTypeIdBeneficiary("");
            setEditByIdBeneficiary("");
        } catch (error) {
            setLoadingRequest(false);
            console.error('There was a problem updating data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowEditFormBeneficiary(false);
    };
    const handleDelete = async () => {
        try {
            setLoadingRequest(true);
            await axios.delete(apiUrlBeneficiary + `/${deleteById}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            setShowDeleteForm(false);
            await fetchData(""); // Assuming fetchData() fetches the updated data for the table
            await fetchDataBeneficiary();
            console.log('Deleted successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
        
            // Reload table data and reset state
            setDeleteById("");
        } catch (error) {
            setLoadingRequest(false);
            console.error('There was a problem deleting employee:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
        
        setShowDeleteForm(false);
    };

    const addHandleClick = () => {
        setShowAddForm(true);
    };
    const addHandleClickBeneficiary = () => {
        setShowAddFormBeneficiary(true);
    };
    const editHandleClick = (data) => {
        setEditById(data.id);
        setEditName(data.name);
        setEditAmount(data.amount);
        setEditBenefitType(data.type);
        setEditIsActive(data.isActive);

        setOldEditName(data.name);
        setOldEditAmount(data.amount);
        setOldEditIsActive(data.isActive);
        setShowEditForm(true);
    };
    const editHandleClickBeneficiary = (data) => {
        setEditByIdBeneficiary(data.id);
        setEditEmployeePersonalInformationIdBeneficiary(data.employeePersonalInformationId);
        setEditEmployeePersonalInformationFullName(data.employeePersonalInformationFullName);
        setEditBenefitIdBeneficiary(data.benefitId);
        setEditPayTypeIdBeneficiary(data.payTypeId);
        setEditIsActiveBeneficiary(data.isActive);

        setOldEditBenefitIdBeneficiary(data.benefitId);
        setOldEditPayTypeIdBeneficiary(data.payTypeId);
        setOldEditIsActiveBeneficiary(data.isActive);
        setShowEditFormBeneficiary(true);
    };
    const deleteHandleClick = (data) => {
        setShowDeleteForm(true);
        setDeleteById(data.id);
    };
    const closeAddHandleClick = () => {
        setShowAddForm(false);
    };
    const closeAddBeneficiaryHandleClick = () => {
        setShowAddFormBeneficiary(false);
    };
    const closeEditHandleClick = () => {
        setShowEditForm(false);
    };
    const closeEditBeneficiaryHandleClick = () => {
        setShowEditFormBeneficiary(false);
    };
    const closeDeleteHandleClick = () => {
        setShowDeleteForm(false);
    };
    const closeEmployeeForm = () => {
        setShowEmployeeForm(false);
    }

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="TransactionInfo">
                        <div className="transaction-header">
                        <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Loans & Benefits >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"Benefits"}</span>
                        </div>
                            <h3>Benefits</h3>
                        </div>
                        <div className="transaction-body">
                            {type === 0 ? 
                                <div>
                                    {Filter(setFilterDataIndex)}
                                    <div className="transaction-body-top row">
                                        {CreateSearchBarWithPlaceHolder("", "transaction-search row", "transaction-search-icon", "transaction-search-input", (e) => handleFilter(e.target.value), searchPlaceholderBenefit, SearchIcon)}
                                        <div className="transaction-addBtn row">
                                            {CreateButton("", "add row", addHandleClick, "ADD", NoteAddIcon)}
                                        </div>
                                    </div>
                                </div>
                                :
                                <div>
                                    {FilterBeneficiary(setFilterDataIndexBeneficiary)}
                                    <div className="transaction-body-top row">
                                        {CreateSearchBarWithPlaceHolder("", "transaction-search row", "transaction-search-icon", "transaction-search-input", (e) => handleFilterBeneficiary(e.target.value), searchPlaceholderBeneficiary, SearchIcon)}
                                        <div className="transaction-addBtn row">
                                            {CreateButton("", "add row", addHandleClickBeneficiary, "ADD", NoteAddIcon)}
                                        </div>
                                    </div>
                                </div>
                            }
                            <div className='loan-tab'>
                                <ShowTab type={type} 
                                        setType={setType} 
                                        benefits={benefits} 
                                        beneficiary={beneficiary} 
                                        editHandleClick={editHandleClick} 
                                        editHandleClickBeneficiary={editHandleClickBeneficiary} 
                                        deleteHandleClick={deleteHandleClick}
                                        loading={loading}
                                        loadingBeneficiary={loadingBeneficiary}
                                        canFullView={isLoanFullView(userAccess.description)}
                                        user={user}
                                        currentPage={currentPage}
                                        setCurrentPage={setCurrentPage}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AddForm  isOpen={showAddForm} 
                    onClose={closeAddHandleClick}
                    name={name}
                    amount={amount}
                    isActive={isActive}
                    setName={setName}
                    setAmount={setAmount}
                    setIsActive={setIsActive}
                    benefitType={benefitType}
                    setBenefitType={setBenefitType}
                    handleSubmit={handleSubmit}
            >
            </AddForm>
            <AddFormBeneficiary  isOpen={showAddFormBeneficiary} 
                    onClose={closeAddBeneficiaryHandleClick}
                    employeePersonalInformationId={employeePersonalInformationId}
                    employeePersonalInformationFullName={employeePersonalInformationFullName}
                    benefitId={benefitId}
                    payTypeId={payTypeId}
                    setEmployeePersonalInformationId={setEmployeePersonalInformationId}
                    setBenefitId={setBenefitId}
                    setPayTypeId={setPayTypeId}
                    setShowEmployeeForm={setShowEmployeeForm}

                    isActive={isActiveBeneficiary}
                    setIsActive={setIsActiveBeneficiary}

                    handleSubmit={handleSubmitBeneficiary}
            >
            </AddFormBeneficiary>
            <EditForm  isOpen={showEditForm} 
                    onClose={closeEditHandleClick}
                    editName={editName}
                    editAmount={editAmount}
                    editIsActive={editIsActive}
                    setEditName={setEditName}
                    setEditAmount={setEditAmount}
                    setEditIsActive={setEditIsActive}
                    editBenefitType={editBenefitType}
                    setEditBenefitType={setEditBenefitType}
                    handleUpdate={handleUpdate}
            >
            </EditForm>
            <EditFormBeneficiary  isOpen={showEditFormBeneficiary} 
                    onClose={closeEditBeneficiaryHandleClick}
                    editEmployeePersonalInformationIdBeneficiary={editEmployeePersonalInformationIdBeneficiary}
                    editEmployeePersonalInformationFullName={editEmployeePersonalInformationFullName}
                    editBenefitIdBeneficiary={editBenefitIdBeneficiary}
                    editPayTypeIdBeneficiary={editPayTypeIdBeneficiary}
                    setEditBenefitIdBeneficiary={setEditBenefitIdBeneficiary}
                    setEditPayTypeIdBeneficiary={setEditPayTypeIdBeneficiary}

                    isActive={editIsActiveBeneficiary}
                    setIsActive={setEditIsActiveBeneficiary}

                    handleUpdate={handleUpdateBeneficiary}
            >
            </EditFormBeneficiary>
            <EmployeeSelectForm  isOpen={showEmployeeForm} 
                    user={user}
                    onClose={closeEmployeeForm}
                    setEmployeeId={setEmployeePersonalInformationId}
                    setEmployee={setEmployeePersonalInformationFullName}
            >
            </EmployeeSelectForm>
            <DeleteForm  isOpen={showDeleteForm} 
                    onClose={closeDeleteHandleClick}
                    handleDelete={handleDelete}
            >
            </DeleteForm>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest || loading || loadingBeneficiary? (
            <div
                style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100vw",
                height: "100vh",
                zIndex: "2000",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                backgroundColor: "#ffffff59",
                }}
            >
                <img src={loadingSpinner} alt="Loading..." />
            </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function ShowTab({type, 
    setType, 
    benefits, 
    beneficiary, 
    editHandleClick, 
    editHandleClickBeneficiary, 
    deleteHandleClick,
    loading, 
    loadingBeneficiary, 
    canFullView,
    user,

    currentPage, setCurrentPage
}){
    const [selectedTab, setSelectedTab] = useState(0);

    var benefitsHeader = [
        "ID",
        "Name",
        "Amount",
        "Benefit Type",
        "Status",
        "",
    ]
    var benefitsAccessor = [
        "id",
        "name",
        "amount",
        "type",
        "status",
        "manage"
    ]
    var beneficiariesHeader = [
        "Employee ID",
        "Name",
        "Benefit",
        // "Pay Type",
        "Enabled?",
        "",
    ]
    var beneficiariesAccessor = [
        "employeePersonalInformationEmployeeId",
        "employeePersonalInformationFullName",
        "benefitName",
        // "payTypeDescription",
        "enable",
        "manage"
    ]

    const beneficiaryFilterByUser = beneficiary.filter(data => data.employeePersonalInformationId === user.employeePersonalInformationId)

    const handleSelectChange = (index) => {
        setCurrentPage(1);
        setSelectedTab(index);
        setType(index);
    };

    return (
        <>
            { canFullView ?
                <Tabs selectedIndex={selectedTab} onSelect={index => handleSelectChange(index)}>
                    <TabList>
                        <Tab><b>BENEFITS</b></Tab>
                        <Tab><b>BENEFICIARIES</b></Tab>
                    </TabList>
                    <div className="loan-tabPanel">
                        <TabPanel>
                            <div className="transaction-table container">
                                <CreateTable
                                        dataList={benefits}
                                        dataHeader={benefitsHeader}
                                        dataAccessor={benefitsAccessor}
                                        type={type}
                                        editHandleClick={editHandleClick}
                                        currentPage={currentPage}
                                        setCurrentPage={setCurrentPage}
                                    />
                                </div>
                        </TabPanel>
                        <TabPanel>
                            <div className="transaction-table container">
                                    <CreateTable
                                        dataList={beneficiary}
                                        dataHeader={beneficiariesHeader}
                                        dataAccessor={beneficiariesAccessor}
                                        type={type}
                                        editHandleClick={editHandleClickBeneficiary}
                                        deleteHandleClick={deleteHandleClick}
                                        currentPage={currentPage}
                                        setCurrentPage={setCurrentPage}
                                    />
                            </div>
                        </TabPanel>
                    </div>
                </Tabs>
                :
                <>
                    <div className="transaction-table container">
                        <CreateTable
                            dataList={beneficiaryFilterByUser}
                            dataHeader={beneficiariesHeader}
                            dataAccessor={beneficiariesAccessor}
                            type={type}
                            editHandleClick={editHandleClickBeneficiary}
                            deleteHandleClick={deleteHandleClick}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                        />
                    </div>
                </>
            }
        </>
    );
};
function AddForm({isOpen, 
    onClose,
    name,
    amount,
    isActive,
    setName,
    setAmount,
    setIsActive,
    benefitType,
    setBenefitType,
    handleSubmit}) 
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(!name || !amount || !benefitType){
            setErrorState(true);
            return;
        }
        handleSubmit(e);
        setErrorState(false);
    };

    const handleIsActiveChange = (event) => {
        setIsActive(event.target.checked);
    };
    const handleClose = () => {
        onClose();
        setName("");
        setAmount("");
        setBenefitType("");
        setIsActive(false);
        setErrorState(false);
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Add Benefit</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Name</div>
                            <div className="info-item-input">
                                <input
                                id="name"
                                placeholder="Name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !name && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Amount</div>
                            <div className="info-item-input">
                                <input
                                type='number'
                                id="amount"
                                placeholder="Amount"
                                value={amount}
                                onChange={(e) => setAmount(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !amount && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Benefit Type</div>
                            <div className="info-item-input">
                                <BenefitTypeSelect benefitType={benefitType} setBenefitType={setBenefitType}/>
                            </div>
                            <span style={{
                                        visibility: !benefitType && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item row" style={{alignItems:"center"}}>
                            <div className="info-item-label" style={{paddingRight:"10px"}}>Is Active?</div>
                            <div className="info-item-input">
                                <input type="checkbox" 
                                id="isActive-checkbox" 
                                className="checkbox" 
                                name="" 
                                checked={isActive}
                                onChange={(e)=>handleIsActiveChange(e)}/>
                            </div>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                SAVE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function AddFormBeneficiary({isOpen, 
    onClose, 
    employeePersonalInformationId,
    employeePersonalInformationFullName,
    benefitId,
    payTypeId,
    setEmployeePersonalInformationId,
    setBenefitId,
    setPayTypeId, 
    setShowEmployeeForm,

    isActive, setIsActive,
    handleSubmit}) 
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(!employeePersonalInformationId || !benefitId){
            setErrorState(true);
            return;
        }
        handleSubmit(e);
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setEmployeePersonalInformationId("");
        setBenefitId("");
        setPayTypeId("");
        setErrorState(false);
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Add Beneficiary</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employee</div>
                            <div className="info-item-input">
                                <div className="info-item-holder employee-select row" style={{flexDirection:"row", justifyContent:"normal"}}>
                                    <input
                                        readOnly
                                        className='employeeInput-select'
                                        placeholder="Employee"
                                        value={employeePersonalInformationId ? (employeePersonalInformationFullName) : employeePersonalInformationId}
                                    />
                                    <button className="select row"
                                            onClick={()=>setShowEmployeeForm(true)}
                                    ><SearchIcon/></button>
                                </div>
                                <span style={{
                                        visibility: !employeePersonalInformationId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                                {/* {EmployeeIdSelect(employeePersonalInformationId, setEmployeePersonalInformationId)} */}
                            </div>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Benefit</div>
                            <div className="info-item-input">
                                <BenefitIdSelect benefitId={benefitId} setBenefitId={setBenefitId}/>
                            </div>
                            <span style={{
                                        visibility: !benefitId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        {/* <div className="popUp-item info-item column">
                            <div className="info-item-label">Pay Type</div>
                            <div className="info-item-input">
                                <PayTypeIdSelect payTypeId={payTypeId} setPayTypeId={setPayTypeId}/>
                            </div>
                            <span style={{
                                        visibility: !payTypeId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div> */}
                        <div className="popUp-item info-item row" style={{alignItems:"center"}}>
                            <div className="info-item-label" style={{paddingRight:"10px"}}>Is Active?</div>
                            <div className="info-item-input">
                                <input type="checkbox" 
                                id="isActive-checkbox" 
                                className="checkbox" 
                                name="" 
                                checked={isActive}
                                onChange={(event)=>setIsActive(event.target.checked)}/>
                            </div>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                SAVE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EditForm({isOpen, 
    onClose, 
    editName, 
    editAmount, 
    editIsActive, 
    setEditName,  
    setEditAmount,  
    setEditIsActive, 
    editBenefitType,
    setEditBenefitType,
    handleUpdate})
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(!editName || !editAmount || !editBenefitType){
            setErrorState(true);
            return;
        }
        handleUpdate(e);
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setErrorState(false);
    };

    const handleIsActiveChange = (event) => {
        setEditIsActive(event.target.checked);
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Update Benefit</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Name</div>
                            <div className="info-item-input">
                                <input
                                id="editName"
                                placeholder="Name"
                                value={editName}
                                onChange={(e) => setEditName(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !editName && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Amount</div>
                            <div className="info-item-input">
                                <input
                                id="editAmount"
                                placeholder="Amount"
                                value={editAmount}
                                onChange={(e) => setEditAmount(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !editAmount && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Benefit Type</div>
                            <div className="info-item-input">
                                <BenefitTypeSelect benefitType={editBenefitType} setBenefitType={setEditBenefitType}/>
                            </div>
                            <span style={{
                                        visibility: !editBenefitType && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item row" style={{alignItems:"center"}}>
                            <div className="info-item-label" style={{paddingRight:"10px"}}>Is Active?</div>
                            <div className="info-item-input">
                                <input type="checkbox" 
                                id="isActive-checkbox" 
                                className="checkbox" 
                                name="" 
                                checked={editIsActive}
                                onChange={(e)=>handleIsActiveChange(e)}/>
                            </div>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                UPDATE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EditFormBeneficiary({isOpen, 
    onClose, 
    editEmployeePersonalInformationIdBeneficiary,
    editEmployeePersonalInformationFullName,
    editBenefitIdBeneficiary,
    editPayTypeIdBeneficiary,
    setEditBenefitIdBeneficiary,
    setEditPayTypeIdBeneficiary, 

    isActive, setIsActive,
    handleUpdate})
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(!editEmployeePersonalInformationIdBeneficiary || !editBenefitIdBeneficiary){
            setErrorState(true);
            return;
        }
        handleUpdate(e);
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setErrorState(false);
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Update Beneficiary</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                    <div className="popUp-item info-item column">
                            <div className="info-item-label">Employee</div>
                            <div className="info-item-input">
                                <input
                                    readOnly
                                    className='employeeInput-select'
                                    placeholder="Primary Approver"
                                    value={editEmployeePersonalInformationFullName}
                                    style={{cursor:"not-allowed"}}
                                />
                            </div>
                            <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Benefit</div>
                            <div className="info-item-input">
                                <BenefitIdSelect benefitId={editBenefitIdBeneficiary} setBenefitId={setEditBenefitIdBeneficiary}/>
                            </div>
                            <span style={{
                                        visibility: !editBenefitIdBeneficiary && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        {/* <div className="popUp-item info-item column">
                            <div className="info-item-label">Pay Type</div>
                            <div className="info-item-input">
                                <PayTypeIdSelect payTypeId={editPayTypeIdBeneficiary} setPayTypeId={setEditPayTypeIdBeneficiary}/>
                            </div>
                            <span style={{
                                        visibility: !editPayTypeIdBeneficiary && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div> */}
                        <div className="popUp-item info-item row" style={{alignItems:"center"}}>
                            <div className="info-item-label" style={{paddingRight:"10px"}}>Is Active?</div>
                            <div className="info-item-input">
                                <input type="checkbox" 
                                id="isActive-checkbox" 
                                className="checkbox" 
                                name="" 
                                checked={isActive}
                                onChange={(event)=>setIsActive(event.target.checked)}/>
                            </div>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                UPDATE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function DeleteForm({isOpen, 
    onClose, 
    handleDelete}
){
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Delete!</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Are you sure you want to delete this employee?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleDelete}
                            style={{marginRight:"5px"}}>
                                DELETE
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EmployeeSelectForm({isOpen,
    user,
    onClose,
    setEmployeeId,
    setEmployee}) 
{
    var header = [
        "Id",
        "Name",
    ]
    var accessor = [
        "employeeId",
        "fullName"
    ]

    const handleClose = () => {
        onClose();
        fetchData();
    };
    const handleProceed = () => {
        onClose();
        setEmployeeId(selectedEmployee.id);
        setEmployee(selectedEmployee.fullName);
        fetchData();
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + `/api/Employee/basic-info/all/active`;

        try {
            setLoading(true);
            const response = await axios.post(apiUrl , user, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
                setEmployees(response.data); // Set the response data to the state
                setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [user])
    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.employeeId.toString().startsWith(lowercaseValue)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }

        setEmployees(res);
    };

    useEffect(() => {
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("Search by name")
                break;
            case 1:
                setSearchPlaceholder("Search by id")
                break;
            default:
                setSearchPlaceholder("Search by name")
                break;
        }
        fetchData();
    }, [fetchData, filterDataIndex]);
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Select Employee</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="transaction-body">
                            <EmployeeFilter setFilterDataIndex={setFilterDataIndex}/>
                            <div className="transaction-body-top row">
                                {CreateSearchBarWithPlaceHolder("", 
                                                                "transaction-search row", 
                                                                "transaction-search-icon", 
                                                                "transaction-search-input", 
                                                                (e)=>handleFilter(e.target.value), 
                                                                searchPlaceholder,
                                                                SearchIcon)}
                            </div>
                        </div>
                    <div className="popUp-body">
                        <div className="select-employee-table">
                            <CreateTableForEmployeeSelect
                                dataList={employees}
                                dataHeader={header}
                                dataAccessor={accessor}
                                setSelectedEmployee={setSelectedEmployee}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                            />
                            {employees?.length > 0 ? (
                                    <div></div>
                            )
                            :
                            (
                                <div>
                                {loading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                        <img src={loadingSpinner} alt="Loading..." />
                                    </div>
                                ) : (
                                        <div> {/*<p>No records to display</p>*/}</div>
                                    )
                                }
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"50px 20px 0 20px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleProceed}>
                                PROCEED
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EmployeeFilter({setFilterDataIndex}){
    const [selectedOption, setSelectedOption] = useState("All");

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "EmployeeId":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="EmployeeId">Employee Id</option>
            </select>
        </div>
    );
};
function Filter(setFilterDataIndex){
    const [selectedOption, setSelectedOption] = useState('');

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "Active":
                setFilterDataIndex(1);
                break;
            case "BenefitId":
                setFilterDataIndex(2);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="Active">Active</option>
                <option value="BenefitId">Benefit Id</option>
            </select>
        </div>
    );
};
function FilterBeneficiary(setFilterDataIndex){
    const [selectedOption, setSelectedOption] = useState('');

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "BeneficiaryId":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="BeneficiaryId">Beneficiary Id</option>
            </select>
        </div>
    );
};
function BenefitIdSelect({benefitId, setBenefitId}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setIsSelected(true);
        setBenefitId(event.target.value);
    };

    const [benefitIds, setBenefitIds] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Benefit/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setBenefitIds(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(benefitId !== "" && benefitId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [benefitId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={benefitId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose benefit</option>
            {benefitIds.map((benefitId) => ( 
                SetBenefitId(benefitId)
            ))}
            </select>
        </div>
    );
};
function SetBenefitId(benefitId){
    return(
        <option id={"leaveType" + benefitId.id} value={benefitId.id}>{
            benefitId.name}
        </option>
    )
    
}
function BenefitTypeSelect({benefitType, setBenefitType}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setIsSelected(true);
        setBenefitType(event.target.value);
    };

    useEffect(() => {
        if(benefitType !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [benefitType]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={benefitType || ""} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose benefit type</option>
            <option value="Daily">Daily</option>
            <option value="PerCutOff">Per Cut Off</option>
            <option value="Monthly">Monthly</option>
            <option value="Once">Once</option>
            </select>
        </div>
    );
};
export function CreateTable({ dataList = [], dataHeader = [], dataAccessor = [], currentPage, setCurrentPage, editHandleClick, deleteHandleClick }) {
    const itemsPerPage = 10;

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows?.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows?.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    return (
        <>
            <table {...getTableProps()}>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th
                                {...column.getHeaderProps()}
                                onClick={() => headerClick(column)}
                                className="sortable-header"
                            >
                                {`${column.render("Header")} ${
                                    sortHeaderValue.id === column.id
                                        ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                        : ""
                                }`}
                            </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {dataList?.length <= 0 &&
                        <tr>
                            <td colSpan={columns?.length} style={{ textAlign: "center" }}>
                                No data to display
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                            <tr key={row.original.id}
                            {...row.getRowProps()}
                            >
                                {row.cells.map((cell) => (
                                    SetInfo(cell.render("Cell").props.column.Header, 
                                            cell,
                                            editHandleClick,
                                            deleteHandleClick)
                                ))}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            {rows?.length > itemsPerPage ? (
            <>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows?.length}
                        style={{ visibility: (rows?.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"26px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows?.length}
                        style={{ visibility: (rows?.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                        &gt;&gt;
                    </button>
                </div>
                {`${currentPage}/${totalPages}`}
            </>
            ) :
            <></>}
        </>
    )
}
function SetInfo(header, _cell, editHandleClick, deleteHandleClick) {
    const data = _cell.render("Cell").props.row.original;

    if (header === "") {
        return(
            <td>
                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <Tooltip text="Update">
                        <div style={{padding:"0 5px"}} onClick={()=>editHandleClick(data)}><ModeEditIcon/></div>
                    </Tooltip>
                    { deleteHandleClick ? 
                    <Tooltip text="Delete">
                        <div style={{padding:"0 5px"}} onClick={()=>deleteHandleClick(data)}><DeleteForeverIcon/></div>
                    </Tooltip>
                    :
                    <></>
                    }
                </div>
            </td>
        )
    }

    if(header === "Status"){
        if(data.isActive){  
            return(
                <td>
                    Active
                </td>
            )
        }
        else{
            return(
                <td>
                    InActive
                </td>
            )
        }
    }

    if(header === "Approved?"){
        return(
            <td>
                <input type="checkbox" 
                    id="overtime-allowance" 
                    className="checkbox"
                    name="" 
                    checked={data.isApproved}
                    disabled={true}
                />
            </td>
        )
    }

    if(header === "Enabled?"){
        return(
            <td>
                <input type="checkbox" 
                    id="overtime-allowance" 
                    className="checkbox"
                    name="" 
                    checked={data.isActive}
                    disabled={true}
                />
            </td>
        )
    }

    if(header === "Time From"
    || header === "Time To"
    || header === "Time In"
    || header === "Time Out"
    ){
        const time = _cell.render("Cell").props.value;
        if(!time) {
            return (
                <td>
                </td>
            );
        }

        let timeParts;
        let formattedTime;

        if (globalTimeFormat === "Standard Time"){
            const timeSplit = time.split('T');
            if (timeSplit?.length > 1) {
                timeParts = timeSplit[1].substr(0, 5).split(':');
            } else {
                timeParts = [];
            }
            let hours = parseInt(timeParts[0], 10);
            const minutes = timeParts[1];

            // Convert 24-hour format to 12-hour format and determine AM or PM
            const amPm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

            formattedTime = `${hours}:${minutes} ${amPm}`;
        } else if (globalTimeFormat === "Military Time"){
            const timeSplit = time.split('T');
            if (timeSplit?.length > 1) {
                timeParts = timeSplit[1].substr(0, 5).split(':');
            } else {
                timeParts = [];
            }
            let hours = parseInt(timeParts[0], 10);
            const minutes = timeParts[1];

            formattedTime = `${hours}:${minutes}`;
        }

        return (
            <td>
                {formattedTime}
            </td>
        );
    }
    
    if(header === "Date"
    || header === "Date From"
    || header === "Date To"
    || header === "Date Processed"
    || header === "Request Date"
    || header === "Date Requested"
    ){
        const date = new Date(_cell.render("Cell").props.value);
        if(!date) {
            return (
                <td>
                </td>
            );
        }

        const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
        const dd = date.getDate();
        const yyyy = date.getFullYear();

        const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
        
        return(
            <td>
                {formattedDateFrom}
            </td>
        )
    }

    //Double type data
    if(header === "Over Percentage"
    || header === "Deduction"
    || header === "Salary"
    || header === "Employee"
    || header === "Employer"
    || header === "Range From"
    || header === "Range To"
    || header === "Monthly Salary"
    || header === "SSS ER"
    || header === "SSS EE"
    || header === "SSS Total"
    || header === "ECER"
    || header === "Total Contribution ER"
    || header === "Total Contribution EE"
    || header === "Total Contribution Total"
    || header === "SE Total Contribution"
    || header === "Salary Range From"
    || header === "Salary Range To"
    || header === "Total Monthly Premium"
    || header === "Percentage"
    || header === "Amount"
    || header === "Total Loan"
    || header === "Total Balance"
    || header === "Default Deduction"
    || header === "Allowance"
    || header === "Daily Salary"
    || header === "Allowance"
    || header === "Total Basic"
    || header === "Rate"
    || header === "Hours OT Regular"
    || header === "Total OT Regular"
    || header === "Hours OT Exceeded"
    || header === "Total OT Exceeded"
    || header === "Hours OT Restday"
    || header === "Total OT Restday"
    || header === "Hours Holiday Special"
    || header === "Total Holiday Special"
    || header === "Hours Holiday Regular"
    || header === "Total Holiday Regular"
    || header === "Hours Restday Holiday Special"
    || header === "Total Restday Holiday Special"
    || header === "Hours Restday Holiday Regular"
    || header === "Total Restday Holiday Regular"
    || header === "Additions"
    || header === "SSS"
    || header === "Pagibig"
    || header === "Philhealth"
    || header === "SSS Loan"
    || header === "SSS Calamity Loan"
    || header === "Pagibig Loan"
    || header === "Pagibig Calamity Loan"
    || header === "Tax"
    || header === "Deductions"
    || header === "Adjustments"
    || header === "Total Net Pay"
    || header === "Days Absent"
    || header === "Absent/s"
    || header === "Days Leave"
    || header === "Leave/s"
    || header === "Hours Exceeded"
    || header === "Total Exceeded"
    || header === "Hours Undertime"
    || header === "Undertime"
    || header === "Hours Late"
    || header === "Late"
    || header === "Night Diff"
    || header === "OT Regular"
    || header === "OT Restday"
    || header === "Holiday Special"
    || header === "Holiday Regular"
    || header === "Restday Holiday Special"
    || header === "Restday Holiday Regular"
    || header === "Total Absents"
    || header === "Total Late"
    || header === "Total Undertime"
    || header === "Total Leaves"
    || header === "Total Night Diff"
    || header === "Total Exceed"
    || header === "Exceed"
    ){
        const value = _cell.render("Cell").props.value;

        // Check if value is a number
        const isNumber = typeof value === 'number';

        const numberWithCommasAndDecimal = (number) => {
            return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        };

        if(!isNumber){
            return (
                <td {..._cell.getCellProps()}> {
                    _cell.render("Cell")
                    }
                </td>
            )
        }

        const formattedNumber = numberWithCommasAndDecimal(value);

        return(
            <td>
                {formattedNumber}
            </td>
        )
    }

    return (
        <td {..._cell.getCellProps()}> {
            _cell.render("Cell")
            }
        </td>
    )
}
const Tooltip = ({ text, children }) => {
    const [show, setShow] = useState(false);

    const handleMouseEnter = () => {
        setShow(true);
    };

    const handleMouseLeave = () => {
        setShow(false);
    };

    return (
        <div style={{ position: 'relative', display: 'inline-block',zIndex:"1" }}>
            <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {children}
            </div>
            {show && (
            <div
                style={{
                position: 'absolute',
                top: '50%',
                left: '-50%',
                transform: 'translateX(-50%)',
                backgroundColor: 'white',
                color: 'gray',
                padding: '5px',
                borderRadius: '5px',
                pointerEvents: "none",
                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
                }}
            >
                {text}
            </div>
            )}
        </div>
    );
};
export default Benefits
